// @flow

import { Model } from '@insolus/backbone';

// - Definitions
type ModelData = {
    subjectId: ?number,
    period: number[],
    day: number[],
    location: number[],
    targetAudience: number[]
};

class CoursesFilter extends Model {
    get defaults(): ModelData {
        return {
            subjectId      : null,
            period         : [],
            day            : [],
            location       : [],
            targetAudience : []
        };
    }
}

export default CoursesFilter;



// WEBPACK FOOTER //
// ./src/views/themes/front/models/courses-filter.js